import { Injectable } from '@angular/core';
import { GlobalVariable } from '../config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AddUpdProcesoInput, UpdProcesoInput } from '../models/addUpdProcesoInput.model';
import { Observable } from 'rxjs';
import { Procesox } from '../models/procesox.model';

@Injectable({
  providedIn: 'root'
})
export class ProcesoMatriculaService {

  url = GlobalVariable.BASE_API_URL;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });
  constructor(private http: HttpClient) { }

  // Simulación
  CreaProceso(simulacionInput: AddUpdProcesoInput) {
    return this.http.post(`${this.url}ProcesoMatricula/CreaActualizaProceso`, simulacionInput, { headers: this.headersc });
  }

  guardarSimulacion(simulacionInput: UpdProcesoInput) {
    return this.http.post(`${this.url}ProcesoMatricula/CreaActualizaProceso`, simulacionInput, { headers: this.headersc });
  }

  GetProceso(idProceso: any): Observable<any> {
    const payload = {
      IdProceso: idProceso
    }
    return this.http.post(
      `${this.url}ProcesoMatricula/getProceso`,
      payload,
      {
        headers: this.headersc
      });
  }
  getIdProcesoById(proceso: string) {
    return this.http.post(`${this.url}ProcesoMatricula/getProceso2/?idproceso=${proceso}`, null, { headers: this.headersc });
  }
  setFase(idpreceso: string, fase: string) {
    return this.http.post(`${this.url}ProcesoMatricula/fase/?idproceso=${idpreceso}&fase=${fase}`, null, { headers: this.headersc });
  }
  CrearProceso(proceso: Procesox) {
    return this.http.post(`${this.url}ProcesoMatricula/CreaActualizaProceso`, JSON.stringify(proceso), { headers: this.headers });
  }
  getProceso2(idproceso: string) {
    let httpParams = new HttpParams()
      .set('idproceso', idproceso)
    return this.http.post(`${this.url}ProcesoMatricula/getProceso2`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  desactivaSimulacion(idproceso: string) {
    let httpParams = new HttpParams()
      .set('idproceso', idproceso)
    return this.http.post(`${this.url}ProcesoMatricula/desactivaSimulacion`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  listaEspera(idproceso: string) {
    let httpParams = new HttpParams()
      .set('idproceso', idproceso)
    return this.http.post(`${this.url}ProcesoMatricula/listaEspera`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  GetCantidadSimulaciones(idContacto: string) {
    let httpParams = new HttpParams()
      .set('idContacto', idContacto)
    return this.http.post(`${this.url}ProcesoMatricula/cantidadSimulacionesCentralizada`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  GetDetallePago(idproceso: string) {
    return this.http.post(`${this.url}PagoMatriculas/ObtienePagoMatricula?idProceso=${idproceso}`, null, { headers: this.headersc });
  }

  GetModalidad(idInstitucion: string, idSede: string, idArea: string, idCarrera: string, jornada: number) {
    return this.http.post(`${this.url}ProcesoMatricula/GetModalidad?idInstitucion=${idInstitucion}&idSede=${idSede}&idArea=${idArea}&idCarrera=${idCarrera}&jornada=${jornada}`, null, { headers: this.headersc });
  }

  CreaProcesoCentralizada(rut, dv) {
    debugger;
      let httpParams = new HttpParams()
        .set('rut', rut)
        .set('dv', dv)
      return this.http.post(`${this.url}ProcesoMatricula/CreaProcesoCentralizada`,
        null,
        {
          headers: this.headersc,
          params: httpParams
        });
    }

}
